import InlineCode from '@primer/gatsby-theme-doctocat/src/components/inline-code';
import { PropTableValues } from "../../../../src/components";
import { Label } from '@primer/react';
import { Heading } from '@primer/react-brand';
import { Link } from 'gatsby';
import * as React from 'react';
export default {
  InlineCode,
  PropTableValues,
  Label,
  Heading,
  Link,
  React
};